"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombineInvoicesTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CombineInvoicesTransport = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    receivableIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }), { minItems: 2 }),
});
//# sourceMappingURL=combine-invoices.js.map